import { useEffect } from "react";

const NEG = /^(-|−)\s?\$\d|^\$-\d|^\(\$\d/;

function mark(el) {
  if (!el || el.nodeType !== 1 || el.children.length) return;
  const neg = NEG.test((el.textContent || "").trim());
  if (neg && !el.hasAttribute("data-neg")) el.setAttribute("data-neg", "");
  else if (!neg && el.hasAttribute("data-neg")) el.removeAttribute("data-neg");
}

function scan(root) {
  if (root.nodeType === 3) return mark(root.parentElement);
  if (root.nodeType !== 1) return;
  mark(root);
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  for (let n = walker.nextNode(); n; n = walker.nextNode()) mark(n.parentElement);
}

// Colours every element whose text is a negative dollar amount (see [data-neg] in index.css).
export function NegativeAmounts() {
  useEffect(() => {
    scan(document.body);
    const obs = new MutationObserver((list) => list.forEach((m) => {
      if (m.type === "characterData") mark(m.target.parentElement);
      else { m.addedNodes.forEach(scan); mark(m.target); }
    }));
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => obs.disconnect();
  }, []);
  return null;
}
